import { observer } from "mobx-react-lite";

import RunInfo from "./RunInfo";

import Message from "@/components/Playground/Messages/Message";
import { IMessageStore } from "@/components/Playground/Messages/Message/message-store";
import { IndividualRun } from "@/types/metadata";

const MessageWithRun = observer(
  ({
    message,
    getMessageRun,
    isMessageCompleted,
    extraControls,
  }: {
    message: IMessageStore;
    getMessageRun: (id: string) => IndividualRun | null;
    isMessageCompleted: (id: string) => boolean;
    extraControls: (id: string) => (JSX.Element | null)[];
  }) => {
    const runData = getMessageRun(message.id);
    return (
      <div className="group h-full w-full">
        <Message
          extraHeader={
            runData && <RunInfo runData={runData} extraControls={extraControls(message.id)} />
          }
          message={message}
          enableJsonOutputDetection
          isOutputMessageComplete={isMessageCompleted(message.id)}
          readonly
        />
      </div>
    );
  },
);

export default MessageWithRun;
